import { FC } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button, AvatarStyled, Separator, BoxProps } from '@bechtel/gds';

export const SeparatorStyled = styled(Separator).attrs({
  color: 'grey.300',
})`
  margin: 0;
`;

interface SelectItemStyledProps extends BoxProps {
  canAdd?: boolean;
}

export const SelectItemStyled = styled(Box as FC<SelectItemStyledProps>).attrs({
  flexDirection: { sm: 'row' },
  alignItems: { sm: 'center' },
  p: { sm: '400' },
})`
  ${({ theme, canAdd  }) =>
    canAdd
      ? css`
          cursor: pointer;
          &:hover {
            background-color: ${theme.colors.bechtel.blue[100]};
          }
        `
      : css`
          pointer-events: none;
          opacity: 0.3;
        `}
`;

export const AddUserStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[700]};
    color: ${theme.colors.white};
    border-color: ${theme.colors.bechtel.blue[700]};
  `};
`;

export const SideSheetSubHeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.grey[200]};
  `}
`;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
  `}
`;

export const CrewMemberListStyled = styled(Box)`
  /* Need to set min-height to handle scroll inside outer scroll*/
  min-height: calc(100% - 311px);
`;

export const AssignButtonStyled = styled(Button)`
  ${({ theme }) => css`
    background-color: ${theme.colors.bechtel.blue[800]};
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    margin-left: ${theme.spacings[600]};
    margin-right: ${theme.spacings[600]};
    text-transform: uppercase;
    font-size: ${theme.fontSizes[400]};
    &:hover {
      background-color: ${theme.colors.bechtel.blue[800]};
    }
  `}
`;

export const AssignSelectedUser = styled(Box).attrs({
  pt: { sm: '450' },
  pb: { sm: '450' },
  mt: { sm: '700' },
})`
  ${({ theme }) => css`
    position: sticky;
    bottom: 0;
    background: ${theme.colors.white};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    /* FIXME - TODO - This is not a good approach but needed this show the border on the left side column */
    margin-left: 1px;
  `}
`;

export const Label = styled('label')`
  display: flex;
  align-items: center;
`;
